// import React from 'react';
// import { BarChart } from '@mui/x-charts';

// const xLabels = [
//     'Jan',
//     'Feb',
//     'Mar',
//     'Apr',
//     'May',
//     'Jun',
//     'Jul',
//     'Aug',
//     'Sep',
//     'Oct',
//     'Nov',
//     'Dec',
// ];

// function InstallerFab({ data }) {
//     const { uniqueCount, totalAmount } = data;

//     return (
//         <BarChart
//             series={[
//                 { data: [uniqueCount], label: 'Total Count' },
//                 { data: [totalAmount], label: 'Total Amount' },
//             ]}
//             xAxis={[
//                 {
//                     data: xLabels,
//                     scaleType: 'band',
//                     tickPlacement: 'middle',
//                 },
//             ]}
//         />
//     );
// }

// export default InstallerFab;

import React from 'react';
import { BarChart } from '@mui/x-charts';
import { useMediaQuery } from '@mui/material';

function InstallerFab({ data, selectedfilter }) {
    const workCount = data?.data?.workCount;
    const paymentSum = data?.data?.paymentSum;
    const isNarrowScreen = useMediaQuery('(max-width:920px)');

    const getChartData = () => {
        if (!workCount || !paymentSum) return { counts: [], amounts: [], labels: [] };

        const labels = Object.keys(workCount);
        const counts = Object.values(workCount);
        const amounts = Object.values(paymentSum);

        return {
            counts,
            amounts,
            labels: labels.map(label => selectedfilter === "day" ? label.split(" ")[0] : label.split(" ")[0])
        };
    };

    const { counts, amounts, labels } = getChartData();

    return (
        <BarChart
            height={250}
            width={isNarrowScreen ? 1200 : 1700}
            series={[
                { data: counts, label: 'Total Count' },
                { data: amounts, label: 'Total Amount' },
            ]}
            xAxis={[
                {
                    data: labels,
                    scaleType: 'band',
                    tickPlacement: 'middle',
                },
            ]}
        />
    );
}

export default InstallerFab;